// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__1P9yl","vLegacy":"SelectSecondary_vLegacy__yFI5Q","error":"SelectSecondary_error__XOQse","disabled":"SelectSecondary_disabled__7GF0p"};